export const popupContainerClassName = "POPUP_CONTAINER";
export const getPopupContainer = (el: HTMLElement): HTMLElement => {
  const modalContainer = el.closest(
    `.${popupContainerClassName}`
  ) as HTMLElement | null;

  return modalContainer || document.body;
};
